import EventBus from '@/event-bus';

import NotificationsModel from '@/services/models/notifications/notification.model';

export default {
  emitNotificationEvent (notification) {
    EventBus.$emit('triggerNotification', new NotificationsModel(notification));
  },
};
